import React from "react";
import { formatINR } from "@/lib/api";

export const PriceBlock = ({ mrp, price, discount, size = "md", className = "" }) => {
  const sizes = {
    sm: { price: "text-base", mrp: "text-xs", badge: "text-[10px] px-1.5 py-0.5" },
    md: { price: "text-xl", mrp: "text-sm", badge: "text-[11px] px-2 py-0.5" },
    lg: { price: "text-3xl", mrp: "text-base", badge: "text-xs px-2.5 py-1" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`flex flex-wrap items-baseline gap-x-2 gap-y-1 ${className}`}>
      <span className={`font-bold text-obsidian ${s.price}`} data-testid="price-selling">
        {formatINR(price)}
      </span>
      {discount > 0 && (
        <>
          <span className={`text-muted-foreground line-through ${s.mrp}`} data-testid="price-mrp">
            {formatINR(mrp)}
          </span>
          <span
            className={`font-semibold uppercase tracking-wider bg-discount text-white ${s.badge}`}
            data-testid="price-discount"
          >
            {discount}% OFF
          </span>
        </>
      )}
    </div>
  );
};
